/** Used as an action type when a ui value is changed */
export const UPDATE_UI = 'UPDATE_UI'
export const UPDATE_UNIT = 'UPDATE_UNIT'
export const CHECK_LOCATION_SEARCH = 'CHECK_LOCATION_SEARCH'



// WEBPACK FOOTER //
// ./src/actions/uiActionTypes.js